import React from "react";

export default {
  'InspectionsTagRow.Wrapper.Buttons.Color.Color': async ({ }, _, internalStateSetter) => {
    internalStateSetter({ editingField: 'color' });
  },
  'InspectionsTagRow.Wrapper.Buttons.Name.Name': async ({ inputRef }, _, internalStateSetter) => {
    internalStateSetter({ editingField: 'name' })
    let newInputRef = inputRef;
    if (!newInputRef) {
      newInputRef = React.createRef({});
      await internalStateSetter({ inputRef: newInputRef });
    }
    newInputRef?.current?.children?.[0]?.focus?.();
  },
  'InspectionsTagRow.Wrapper.InputWrapper.TagInput': ({ value, maxLength }, _, internalStateSetter) => {
    if (maxLength && value.length > maxLength) return;
    internalStateSetter({ value })
  },
  'InspectionsTagRow.Wrapper.InputWrapper.TagInput(Keydown)': ({ value, maxLength, key, tag, color, priority_id, property_ids, group_ids, auto_add_new_properties }, outlet, internalStateSetter) => {
    if (maxLength && value.length > maxLength) return;
    if (!value) return;
    if (key === 'Enter') {
      outlet({ action: 'change', tag: { ...tag, color: color, name: value, priority_id, property_ids, group_ids, auto_add_new_properties } });
      internalStateSetter({ value: "", editingField: null });
    }
  },
  'InspectionsTagRow.Wrapper.Buttons.Delete.Delete': ({ tag }, outlet) => {
    outlet({ action: 'delete', tag });
  },
  'InspectionsTagRow.Wrapper.ColorsWrapper.SaveButton': ({ value, color, tag, priority_id, group_ids, property_ids, auto_add_new_properties }, outlet, internalStateSetter) => {
    if (!value) return;
    outlet({ action: 'change', tag: { ...tag, color: color, name: value, priority_id, group_ids, property_ids, auto_add_new_properties } });
    internalStateSetter({ editingField: null });
  },
  'InspectionsTagRow.Wrapper.TagTextWrapper': async ({ inputRef }, _, internalStateSetter) => {
    internalStateSetter({ editingField: 'name' })
    let newInputRef = inputRef;
    if (!newInputRef) {
      newInputRef = React.createRef({});
      await internalStateSetter({ inputRef: newInputRef });
    }
    newInputRef?.current?.children?.[0]?.focus?.();
  },
  'InspectionsTagRow.Wrapper.ColorsWrapper.CancelButton': ({ tag }, _, internalStateSetter) => {
    internalStateSetter({
      editingField: null,
      color: tag?.color ?? '',
      value: tag?.name ?? '',
      priority_id: tag?.priority_id ?? null,
      group_ids: tag?.group_ids,
      property_ids: tag?.property_ids,
      auto_add_new_properties: tag?.auto_add_new_properties,
    });
  },
  'InspectionsTagRow.Wrapper.ColorsWrapper.TagColorSelect': ({ color }, _, internalStateSetter) => {
    internalStateSetter({ color })
  },
  'InspectionsTagRow.Wrapper.Buttons.Priority.BellWrapper.Bell': ({ }, _, internalStateSetter) => {
    internalStateSetter({ editingField: 'priority' })
  },
  'InspectionsTagRow.Wrapper.ColorsWrapper.PrioritySelect': ({ id }, _, internalStateSetter) => {
    internalStateSetter({ priority_id: id })
  },
  'InspectionsTagRow.Wrapper.Buttons.Location.LocationWrapper.Location': ({ }, _, internalStateSetter) => {
    internalStateSetter({ editingField: 'property' })
  },
  'InspectionsTagRow.Wrapper.ColorsWrapper.PropertyContainer': ({ selectedPropertyIds, selectedGroupIds, auto_add_new_properties }, _, internalStateSetter) => {
    internalStateSetter({ group_ids: selectedGroupIds, property_ids: selectedPropertyIds, auto_add_new_properties: auto_add_new_properties, })
  },
  'InspectionsTagRow.Wrapper.Buttons.Copy.Copy': ({ tag }, outlet) => {
    outlet({ action: 'copy', tag });
  }
}